module.exports = __webpack_public_path__ + "static/hero_image-280c05248a1cd364399284f41809c5e0.png";